import React from 'react'
import {Link} from 'react-router-dom'
import "./AppHeader.css"


function AppHeader(){

return(
    <nav className="nav-wrapper appHeader">
        <Link to="/" className="waves-effect btn-flat homeBtn">Home</Link>
    </nav>
)

}

export default AppHeader